import { Injectable } from '@angular/core';
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {DaoGeneric} from "@Services/base/daoService";
import {Box, BoxType} from "app/archivage/common/services/box/box.model";

@Injectable({
  providedIn: 'root'
})
export class BoxService extends DaoGeneric<Box> {
  private url = `${environment.baseUrl}/api_archive/box/`;
  readonly boxType: string[] = [];

  constructor(private httpClient: HttpClient) {
    super(httpClient);

    this.boxType[BoxType.UNDEF] = 'Non défini';
    this.boxType[BoxType.SMALL] = '10 cm';
    this.boxType[BoxType.MEDIUM] = '15 cm';
  }

  getRootUrl(): string {
    return this.url;
  }

  displayBoxType(box: Box): string {
    return this.boxType[box?.type ?? BoxType.UNDEF]
  }

  selectBoxType() {
    return [
      {id: BoxType.SMALL, label: this.boxType[BoxType.SMALL]},
      {id: BoxType.MEDIUM, label: this.boxType[BoxType.MEDIUM]},
    ];
  }
}
